/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Pobierz załączniki'
  },
  HEADER: {
    DATE: 'Data',
    SENT_BY_F: 'Przesłane przez',
    TITLE: 'Tytuł'
  },
  LABEL: {
    ATTACHMENTS: 'Załączniki',
    DATE: 'Data',
    DETAIL: 'Szczegóły',
    MESSAGE: 'Wiadomość',
    NO_ROWS_COMMUNICATIONS: 'Brak komunikacji',
    SENT_BY_F: 'Przesłane przez',
    TITLE: 'Tytuł',
    UNREAD: 'Nieprzeczytane'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
